import type { PropsWithChildren } from 'react';
import { memo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';
import { theme } from '@frameio/vapor';

type TransferSheetFooterLayoutProps = PropsWithChildren<{
  isShowing: boolean;
}>;

export const TransferSheetFooterLayout = memo(
  function TransferSheetFooterLayout({
    isShowing,
    children,
  }: TransferSheetFooterLayoutProps) {
    return (
      <AnimatePresence initial={false}>
        {isShowing && (
          <FooterContainer
            animate="in"
            exit="out"
            initial="out"
            variants={variants}
          >
            <FooterGradient
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              initial={{
                opacity: 0,
              }}
            />
            <StyledFooter>{children}</StyledFooter>
          </FooterContainer>
        )}
      </AnimatePresence>
    );
  }
);

export const FIXED_FOOTER_HEIGHT = 75;

const FooterGradient = styled(motion.div)`
  background-image: ${theme.colors.background.scrollBottom};
  bottom: 80%;
  height: ${theme.spaces[48]};
  pointer-events: none;
  position: absolute;
  width: 100%;
  z-index: ${theme.zIndices.negative};
`;

const StyledFooter = styled.footer`
  background: ${theme.colors.components.sheet.background};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.radii[8]};
  display: block;
`;

const FooterContainer = styled(motion.div)`
  bottom: 0;
  height: ${FIXED_FOOTER_HEIGHT}px;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 1;
`;

const variants = {
  out: {
    transform: 'translateY(100%)',
    opacity: 0.5,
  } as const,
  in: {
    transform: 'translateY(0)',
    opacity: 1,
  } as const,
};
